module.exports = __webpack_public_path__ + "img/Temp.22b4ca6e.jpg";